import type { components } from "./_generated/schema";
import { apiFetch } from "./apiFetch";

export type ApprovalOut = components["schemas"]["ApprovalOut"];
export type ApprovalListOut = components["schemas"]["ApprovalListOut"];

/** Every gate waiting on a person in this tenant, oldest first.
 *
 *  Deliberately not filtered to the caller: a gate you cannot decide is still
 *  a run that is stuck, and each row carries `can_decide` plus the reason it
 *  is false, so the UI explains rather than hides. */
export function listPendingApprovals(token: string): Promise<ApprovalListOut> {
  return apiFetch<ApprovalListOut>("/api/v1/approvals", { token });
}

/** Every gate one run reached, decided or not — what the canvas shows while a
 *  run sits waiting. */
export function listRunApprovals(
  token: string,
  pipelineId: string,
  runId: string,
): Promise<ApprovalListOut> {
  return apiFetch<ApprovalListOut>(
    `/api/v1/pipelines/${encodeURIComponent(pipelineId)}/runs/${encodeURIComponent(runId)}/approvals`,
    { token },
  );
}

/** Answer a gate: the run resumes, or it stops here. A rejection must carry a
 *  comment — the server refuses one without (the person who has to fix it is
 *  the one who reads it). */
export function decideApproval(
  token: string,
  approvalId: string,
  input: { approved: boolean; comment: string },
): Promise<ApprovalOut> {
  return apiFetch<ApprovalOut>(`/api/v1/approvals/${encodeURIComponent(approvalId)}/decision`, {
    method: "POST",
    token,
    json: input,
  });
}
